import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) navigate("/app");
        else setError(res.error);
    };

    return (
        <main className="container-page py-16 max-w-md">
            <h1 className="text-4xl font-semibold text-[#1C2321] mb-2" style={{ fontFamily: "Outfit" }}>Welcome back</h1>
            <p className="text-[#515B57] text-lg mb-8">Sign in to continue your reading journey.</p>

            <form onSubmit={submit} className="space-y-5" data-testid="login-form">
                <div>
                    <label className="block text-sm font-medium text-[#1C2321] mb-2">Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        autoComplete="email"
                        data-testid="login-email-input"
                        className="w-full px-4 py-3 rounded-lg border border-[#E5E7E2] bg-white text-[#1C2321] text-lg focus:outline-none focus:ring-2 focus:ring-[#2D5D4E] focus:border-transparent"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-[#1C2321] mb-2">Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        autoComplete="current-password"
                        data-testid="login-password-input"
                        className="w-full px-4 py-3 rounded-lg border border-[#E5E7E2] bg-white text-[#1C2321] text-lg focus:outline-none focus:ring-2 focus:ring-[#2D5D4E] focus:border-transparent"
                    />
                    <div className="mt-2 text-right">
                        <Link
                            to="/forgot-password"
                            data-testid="login-forgot-link"
                            className="text-sm text-[#2D5D4E] font-medium hover:underline"
                        >
                            Forgot password?
                        </Link>
                    </div>
                </div>
                {error && (
                    <p className="text-[#B24C4C] text-base" data-testid="login-error">{error}</p>
                )}
                <button
                    type="submit"
                    disabled={loading}
                    data-testid="login-submit-button"
                    className="w-full py-3.5 rounded-lg bg-[#2D5D4E] text-[#FAF9F6] text-lg font-medium hover:bg-[#1F4237] transition-colors disabled:opacity-50"
                >
                    {loading ? "Signing in…" : "Sign in"}
                </button>
            </form>

            <p className="mt-8 text-[#515B57]">
                New here?{" "}
                <Link to="/register" className="text-[#2D5D4E] font-medium hover:underline" data-testid="login-go-register">
                    Create an account
                </Link>
            </p>
        </main>
    );
}
